import { Blocker } from "react-router-dom";
import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import i18n from "src/i18n";


interface Props {
  setIsCalling: (arg: boolean) => void;
  blocker: Blocker;
  onConfirmCallback: () => void;
}

export const openBlockNavigationModal = ({
  setIsCalling,
  blocker,
  onConfirmCallback,
}: Props) => {
  return modals.openConfirmModal({
    withinPortal: true,
    zIndex: 99999,
    title: <Text fw={500}>{i18n.t("leave-current-page-title")}</Text>,
    centered: true,
    children: (
      <Text lh={1.5} fz={14}>
        {i18n.t("leave-current-page-message")}
      </Text>
    ),
    labels: { confirm: i18n.t("leave-page"), cancel: i18n.t("cancel") },
    groupProps: { gap: "xs", mt: "lg" },
    confirmProps: { color: "red" },
    onCancel: () => {
      if (blocker.reset) blocker.reset();
    },
    onConfirm: () => {
      setIsCalling(false);
      onConfirmCallback();
      if (blocker.proceed) blocker.proceed();
    },
    onClose: () => {
      if (blocker.reset) blocker.reset();
    },
    styles: { body: { minHeight: "auto" } },
  });
};
